import {normalizeArrayFields} from '@/shared/lib/util/Util'
import {Checkbox, Form, Input, Spin} from 'antd'
import siteApi from 'common/api/SiteApi.ts'
import {AnchorsForm} from 'common/components/AnchorsForm.tsx'
import {ButtonsPanel} from 'common/components/ButtonsPanel.tsx'
import {FormCard} from 'common/components/FormCard.tsx'
import {IABCategoriesSelector} from 'common/components/IABCategoriesSelector.tsx'
import {PublisherSelector} from 'common/components/reloadable/PublisherSelector.tsx'
import {useAppContext} from 'common/context/AppContext.tsx'
import {CommonRoutes} from 'common/context/commonRoutes'
import { queueListRepositionOnModifiedChange } from 'common/util/listNavigation.ts';
import {apiCall, FormMode} from 'common/util/Util.tsx'
import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'

const FormItem = Form.Item

interface SiteFormProps {
    mode: 'create' | 'edit'
}

const SiteForm: React.FC<SiteFormProps> = ({ mode }) => {
    const navigateTo = useNavigate()
    const [loading, setLoading] = useState(false)

    const { id } = useParams<{ id?: string }>()
    const idNum = id ? parseInt(id) : 0
    const appContext = useAppContext()
    const [form] = Form.useForm()
    const [entity, setEntity] = useState<any>({})

    const handleSubmit = () => {
        normalizeArrayFields(['domainBlackList'], form)

        form.validateFields().then((values) => {
            apiCall(
                setLoading,
                appContext,
                () => {
                    if (mode === 'create') {
                        return siteApi.create({ ...values })
                    } else {
                        return siteApi.edit(idNum, { ...values })
                    }
                },
                (response) => {
                    queueListRepositionOnModifiedChange({
                        appContext,
                        routeKey: CommonRoutes.SITE,
                        previousEntity: entity,
                        responseEntity: response?.data,
                        enabled: mode === FormMode.edit
                    })

                    navigateTo(CommonRoutes.SITE)
                })

        })
    }

    const onCancel = () => {
        navigateTo(CommonRoutes.SITE)
    }

    const onDelete = () => {
        apiCall(setLoading, appContext, () => siteApi.delete(idNum), () => navigateTo(CommonRoutes.SITE))
    }

    const loadData = async () => {
        if (mode === 'edit') {
            apiCall(setLoading, appContext, () => siteApi.view(idNum), (res) => {
                if (res?.data) {
                    setEntity(res.data)
                    form.setFieldsValue({ ...res.data })
                }
            })
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    return (
        <Spin spinning={loading}>
            <AnchorsForm form={form} onFinish={handleSubmit}>
                <FormCard
                    id="site"
                    title="Site"
                >
                    <FormItem name="publisherId" label="Publisher" required>
                        <PublisherSelector
                            placeholder="Select Publisher"
                            disabled={mode === 'edit'}
                        />
                    </FormItem>
                    <FormItem
                        required
                        name="name"
                        rules={[{ required: true, message: 'Please input Site name' }]} label="Name"
                    >
                        <Input />
                    </FormItem>
                    <FormItem
                        required
                        name="domain"
                        rules={[{ required: true, message: 'Please input Site domain' }]} label="Domain / Bundle ID"
                    >
                        <Input />
                    </FormItem>
                    <FormItem name="active" label="Active" valuePropName="checked" initialValue={true}>
                        <Checkbox />
                    </FormItem>
                </FormCard>
                <FormCard
                    id="settings"
                    title="Settings"
                >
                    <FormItem name="iabCategoryIdList" label="IAB Categories">
                        <IABCategoriesSelector />
                    </FormItem>
                    <FormItem name="iabCategoryIdBlackList" label="Blocked IAB Categories">
                        <IABCategoriesSelector />
                    </FormItem>
                    <FormItem name="domainBlackList" label="Domains/Brands Black List">
                        <Input />
                    </FormItem>
                </FormCard>
                <ButtonsPanel onCancel={onCancel} showDelete={mode === FormMode.edit}
                              onDelete={onDelete} />
            </AnchorsForm>
        </Spin>
    )
}

export default SiteForm 
